/**
 * 게스트가 눌러본 책 하나를 기억해둔다.
 *
 * 게스트는 '지금 펼쳐진 책들' 에서 남의 책을 구경하다가 가입한다. 그런데
 * 가입하면 빈 행성으로 떨어지고, 방금 관심을 보인 책은 사라진다. 첫 책이
 * 벽인데(1권 이하에서 멈춘 사람이 42%) 그 벽 앞에 맨손으로 세우는 셈이다.
 *
 * 눌러본 책을 담아두고 가입 직후 내민다. 첫 권이 한 번 누르기가 된다.
 */
const KEY = "muroo_guest_pick";
/** 하루가 지나면 잊는다. 지난주에 구경한 책을 오늘 내밀면 엉뚱하다. */
const TTL = 24 * 60 * 60 * 1000;

export function rememberGuestPick(book) {
  if (!book?.title) return;
  try {
    localStorage.setItem(KEY, JSON.stringify({
      title: book.title,
      author: book.author ?? "",
      cover: book.cover ?? null,
      genre: book.genre ?? null,
      at: Date.now(),
    }));
  } catch {
    /* 시크릿 모드 등에서 막힌다. 기억하지 못해도 가입은 되어야 한다. */
  }
}

export function readGuestPick() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const p = JSON.parse(raw);
    if (!p?.title || !p?.at || Date.now() - p.at > TTL) {
      localStorage.removeItem(KEY);
      return null;
    }
    return p;
  } catch {
    return null;
  }
}

export function clearGuestPick() {
  try { localStorage.removeItem(KEY); } catch { /* 무시 */ }
}
